import dateFormat from "dateformat";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { CustomerBooking } from "rsl-api-106/lib/types";

type LVE1TrackingProps = {
  reservation: CustomerBooking;
};

const LVE1Tracking: React.FC<LVE1TrackingProps> = ({ reservation }) => {
  useEffect(() => {
    if (reservation) {
      const CLVE = (c: string) => {
        let match = document.cookie.match(
          RegExp("(?:^|;\\s*)" + c + "=([^;]*)")
        );
        return match ? match[1] : null;
      };

      // Si le cookie existe et est non vide alors on comptabilise la vente
      let tracking_lve = CLVE("tracking_lve");

      if (tracking_lve !== null && tracking_lve !== "") {
        let montant = reservation.totalAmount?.amount; // montant de la vente

        let partenaire = "Vacanceole"; // nom partenaire

        let produit =
          /*[Reservation.Etab.StationLabel quote="javascript"] +*/ "|" +
          reservation.property?.label +
          "|" +
          getRoomReservationLabel(); // station|residence|produit (attention a bien echapper les apostrophes)

        let date_debut = dateFormat(
          new Date(reservation.startDate),
          "yyyy-mm-dd"
        ); // date debut sejour YYYY-MM-JJ

        let date_fin = dateFormat(new Date(reservation.endDate), "yyyy-mm-dd"); // date fin sejour YYYY-MM-JJ

        let id_commande = `${reservation.id!!}`; // ID de la commande

        let client = reservation.primaryOccupant?.firstName!!; // facultatif - nom client

        (partenaire = partenaire.replace(/[^a-zA-Z0-9]/gi, "-")),
          (produit = produit.replace(/[^a-zA-Z0-9]/gi, "-")),
          (date_debut = date_debut.replace(/[^a-zA-Z0-9]/gi, "-")),
          (date_fin = date_fin.replace(/[^a-zA-Z0-9]/gi, "-")),
          (id_commande = id_commande.replace(/[^a-zA-Z0-9]/gi, "-")),
          (client = client.replace(/[^a-zA-Z0-9]/gi, "-"));

        let pixel_lve = new Image();

        pixel_lve.src =
          "//www.lvestats.com/vente?tracking_lve=" +
          tracking_lve +
          "&montant=" +
          montant +
          "&partenaire=" +
          partenaire +
          "&produit=" +
          produit +
          "&date_debut=" +
          date_debut +
          "&date_fin=" +
          date_fin +
          "&id_commande=" +
          id_commande +
          "&client=" +
          client;
      }
    }
  }, []);

  const getRoomReservationLabel = (): string => {
    let code: string[] = [];
    reservation?.stays?.forEach((stay) => {
      stay?.distribution?.roomTypes?.forEach((ri) => {
        code = [...code, ri?.label ?? ""];
      });
    });
    return code.join(" / ");
  };

  return <></>;
};

LVE1Tracking.propTypes = {
  //
};

export default LVE1Tracking;
